exports = module.exports = require("../../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.25.0@css-loader?{}!./node_modules/_sass-loader@4.0.2@sass-loader?{"sourceMap":true}!./node_modules/_postcss-loader@1.3.3@postcss-loader?{"sourceMap":true}!./src/app/module/customUI/style.scss
// module id = 207
// module chunks = 0 1